import { createPortal } from 'react-dom'
import GoalsTypesReference from './GoalsTypesReference'
import './SentimentThemeDrawer.css'

/**
 * Side drawer: “How goals work?” — goal types, metrics, targets, and progress (matches sentiment drawer shell).
 * Rendered via portal so fixed positioning isn’t trapped under dashboard stacking contexts (z-index & overflow).
 */
export default function GoalsPreActivationDrawer({ isOpen, onClose, referenceProps }) {
  if (!isOpen) return null

  return createPortal(
    <div
      className="std-drawer-overlay std-drawer-overlay--goals-help"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="std-drawer-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="goals-pre-drawer-title"
      >
        <div className="std-drawer-header">
          <div>
            <h2 id="goals-pre-drawer-title" className="std-drawer-title">
              How goals work?
            </h2>
            <p className="std-drawer-subtitle">
              Each goal type groups related metrics. Below you can see what we track, each metric&apos;s default
              target, and how progress appears on the Goals tab after you activate.
            </p>
          </div>
          <button type="button" className="std-drawer-close" onClick={onClose} aria-label="Close drawer">
            <span className="std-close-icon" />
          </button>
        </div>
        <div className="std-drawer-body">
          <GoalsTypesReference {...referenceProps} />
        </div>
      </div>
    </div>,
    document.body
  )
}
